/**
 * Generated by orval 🍺
 * Do not edit manually.
 * ZEP QUIZ
 * Zep Quiz API
 * OpenAPI spec version: 0.0.1
 */

export type GetQuizsetRankingsSchoolType =
  (typeof GetQuizsetRankingsSchoolType)[keyof typeof GetQuizsetRankingsSchoolType];

export const GetQuizsetRankingsSchoolType = {
  KINDERGARTEN: 'KINDERGARTEN',
  PRIMARY: 'PRIMARY',
  MIDDLE: 'MIDDLE',
  HIGH: 'HIGH',
  ESL_ELL: 'ESL_ELL',
  FOREIGN_LANGUAGE: 'FOREIGN_LANGUAGE',
  COLLEGE: 'COLLEGE',
  EXTERNAL_PROGRAM_AP: 'EXTERNAL_PROGRAM_AP',
  EXTERNAL_PROGRAM_IB: 'EXTERNAL_PROGRAM_IB',
  OTHER: 'OTHER',
} as const;
